import React, { memo } from 'react';

import './FacilityCancelled.css';

const FacilityCancelledBadge = () => {
	return <div className="facility__cancelled--badge">FACILITY CANCELLED</div>;
};

export default memo(FacilityCancelledBadge);
